import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

export { msalConfig, graphScopes, loginRequest } from './msalConfig';
